import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'typeBadge',
})
export class TypeBadgePipe implements PipeTransform {
  private readonly typeBadgeMap: { [key: string]: string } = {
    black: 'assets/icons/new-dashboard/black-badge.svg',
    gold: 'assets/icons/new-dashboard/gold-badge.svg',
    silver: 'assets/icons/new-dashboard/silver-badge.svg',
    blue: 'assets/icons/new-dashboard/blue-badge.svg',
    unknown: 'assets/icons/new-dashboard/unknown-badge.svg',
  };

  public transform(value: string | null | undefined): string {
    const key = value ? value.toLowerCase() : 'unknown';
    return this.typeBadgeMap[key] || this.typeBadgeMap.unknown;
  }
}
